import KakaoTalkButton from '@/components/feature/KakaoTalkButton';

export default function CtaSection() {
  return (
    <section className="w-full py-0 relative overflow-hidden" style={{ minHeight: '420px' }}>
      {/* Split layout: left dark, right image */}
      <div className="flex flex-col md:flex-row min-h-[420px]">
        {/* Left */}
        <div
          className="flex-1 flex flex-col justify-center px-8 md:px-16 py-16"
          style={{ backgroundColor: '#0d2b24' }}
        >
          <p className="text-xs font-semibold tracking-widest uppercase mb-4" style={{ color: '#6fcfb8' }}>
            REGISTER NOW
          </p>
          <h2 className="text-2xl md:text-4xl font-bold text-white leading-tight mb-4">
            간병보험금 청구의 시작은<br />
            <span style={{ color: '#6fcfb8' }}>가족간병 등록</span>입니다.
          </h2>
          <p className="text-sm leading-relaxed mb-8" style={{ color: 'rgba(255,255,255,0.55)' }}>
            코리아케어러스에 등록하면 보험사에서 인정하는<br />
            간병인으로 활동하실 수 있습니다. 등록비 없이 무료!
          </p>
          <div className="flex flex-wrap gap-3">
            <a
              href="/register"
              className="px-7 py-3.5 rounded-xl text-sm font-bold text-white whitespace-nowrap cursor-pointer hover:opacity-90 transition-opacity"
              style={{ backgroundColor: '#2E7D6B' }}
            >
              <i className="ri-user-add-line mr-2"></i>가족간병 등록 바로가기
            </a>
            <a
              href="/caregiver-job"
              className="px-7 py-3.5 rounded-xl text-sm font-bold text-white whitespace-nowrap cursor-pointer hover:opacity-90 transition-opacity"
              style={{ backgroundColor: '#EA8C00' }}
            >
              <i className="ri-briefcase-line mr-2"></i>간병인 일자리
            </a>
            <a
              href="tel:15668654"
              className="px-7 py-3.5 rounded-xl text-sm font-bold whitespace-nowrap cursor-pointer hover:opacity-80 transition-opacity"
              style={{ border: '1px solid rgba(255,255,255,0.2)', color: 'rgba(255,255,255,0.8)' }}
            >
              <i className="ri-phone-line mr-2"></i>1566-8654
            </a>
            <KakaoTalkButton
              className="px-7 py-3.5 rounded-xl text-sm font-bold whitespace-nowrap cursor-pointer hover:opacity-90 transition-opacity"
              style={{ backgroundColor: '#FEE500', color: '#391B1B' }}
              ariaLabel="카톡 상담"
            >
              <i className="ri-kakao-talk-fill mr-2"></i>카톡 상담
            </KakaoTalkButton>
          </div>
        </div>
        {/* Right: image */}
        <div className="flex-1 relative min-h-[280px]">
          <img
            src="https://readdy.ai/api/search-image?query=Korean%20caregiver%20team%20in%20green%20uniforms%20standing%20together%20in%20bright%20hospital%20corridor%2C%20professional%20and%20caring%20expressions%2C%20clean%20modern%20hospital%20setting%2C%20warm%20natural%20light%2C%20photorealistic%2C%20high%20quality&width=800&height=500&seq=kccta1&orientation=landscape"
            alt="코리아케어러스 가족간병 등록"
            className="w-full h-full object-cover object-top"
          />
          <div
            className="absolute inset-0"
            style={{ background: 'linear-gradient(to right, #0d2b24 0%, transparent 20%)' }}
          ></div>
        </div>
      </div>
    </section>
  );
}
